module.exports = __webpack_public_path__ + "static/img/tb_rz.816d249.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tb_rz.png
// module id = 8Iy5
// module chunks = 0